/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

/*============================================================================
    Money Format
    - Shopify.format money is defined in option_selection.js.
        If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
    Shopify.formatMoney = function(cents, format) {
        var value = '',
                placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
                formatString = (format || this.money_format);

        if (typeof cents == 'string') {
            cents = cents.replace('.','');
        }

        function defaultOption(opt, def) {
            return (typeof opt == 'undefined' ? def : opt);
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ',');
            decimal   = defaultOption(decimal, '.');

            if (isNaN(number) || number == null) {
                return 0;
            }

            number = (number/100.0).toFixed(precision);

            var parts   = number.split('.'),
                    dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                    cents   = parts[1] ? (decimal + parts[1]) : '';

            return dollars + cents;
        }

        switch(formatString.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
        }

        return formatString.replace(placeholderRegex, value);
    };
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
    timber.cache = {
        // General
        $html                    : $('html'),
        $body                    : $('body'),

        // Navigation
        $navigation              : $('#AccessibleNav'),
        $mobileSubNavToggle      : $('.mobile-nav__toggle'),

        // Collection Pages
        $changeView              : $('.change-view'),

        // Product Page
        $productImage            : $('#ProductPhotoImg'),
        $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),

        // Customer Pages
        $recoverPasswordLink     : $('#RecoverPassword'),
        $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
        $recoverPasswordForm     : $('#RecoverPasswordForm'),
        $customerLoginForm       : $('#CustomerLoginForm'),
        $passwordResetSuccess    : $('#ResetSuccess')
    };
};

timber.init = function () {
    FastClick.attach(document.body);
    timber.cacheSelectors();
    timber.accessibleNav();
    timber.drawersInit();
    timber.mobileNavToggle();
    timber.productImageSwitch();
    timber.responsiveVideos();
    timber.collectionViews();
    timber.loginForms();
};

timber.accessibleNav = function () {
    var $nav = timber.cache.$navigation,
            $allLinks = $nav.find('a'),
            $topLevel = $nav.children('li').find('a'),
            $parents = $nav.find('.site-nav--has-dropdown'),
            $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
            activeClass = 'nav-hover',
            focusClass = 'nav-focus';

    // Mouseenter
    $parents.on('mouseenter touchstart', function(evt) {
        var $el = $(this);

        if (!$el.hasClass(activeClass)) {
            evt.preventDefault();
        }

        showDropdown($el);
    });

    // Mouseout
    $parents.on('mouseleave', function() {
        hideDropdown($(this));
    });

    $subMenuLinks.on('touchstart', function(evt) {
        // Prevent touchstart on body from firing instead of link
        evt.stopImmediatePropagation();
    });

    $allLinks.focus(function() {
        handleFocus($(this));
    });

    $allLinks.blur(function() {
        removeFocus($topLevel);
    });

    // accessibleNav private methods
    function handleFocus ($el) {
        var $subMenu = $el.next('ul'),
                hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
                isSubItem = $('.site-nav__dropdown').has($el).length,
                $newFocus = null;

        // Add focus class for top level items, or keep menu shown
        if (!isSubItem) {
            removeFocus($topLevel);
            addFocus($el);
        } else {
            $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
            addFocus($newFocus);
        }
    }

    function showDropdown ($el) {
        $el.addClass(activeClass);

        setTimeout(function() {
            timber.cache.$body.on('touchstart', function() {
                hideDropdown($el);
            });
        }, 250);
    }

    function hideDropdown ($el) {
        $el.removeClass(activeClass);
        timber.cache.$body.off('touchstart');
    }

    function addFocus ($el) {
        $el.addClass(focusClass);
    }

    function removeFocus ($el) {
        $el.removeClass(focusClass);
    }
};

timber.drawersInit = function () {
    timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
    timber.RightDrawer = new timber.Drawers('CartDrawer', 'right', {
        'onDrawerOpen': ajaxCart.load
    });
};

timber.mobileNavToggle = function () {
    timber.cache.$mobileSubNavToggle.on('click', function() {
        $(this).parent().toggleClass('mobile-nav--expanded');
    });
};

timber.getHash = function () {
    return window.location.hash;
};

timber.updateHash = function (hash) {
    window.location.hash = '#' + hash;
    $('#' + hash).attr('tabindex', -1).focus();
};

timber.productPage = function (options) {
    var moneyFormat = options.money_format,
            variant = options.variant,
            selector = options.selector;

    // Selectors
    var $productImage = $('#ProductPhotoImg'),
            $addToCart = $('#AddToCart'),
            $productPrice = $('#ProductPrice'),
            $comparePrice = $('#ComparePrice'),
            $quantityElements = $('.quantity-selector, label + .js-qty'),
            $addToCartText = $('#AddToCartText');

    if (variant) {

        // Update variant image, if one is set
        if (variant.featured_image) {
            var newImg = variant.featured_image,
                    el = $productImage[0];
            Shopify.Image.switchImage(newImg, el, timber.switchImage);
        }

        // Select a valid variant if available
        if (variant.available) {
            // Available, enable the submit button, change text, show quantity elements
            $addToCart.removeClass('disabled').prop('disabled', false);
            $addToCartText.html("Add to Bag");
            $quantityElements.show();
        } else {
            // Sold out, disable the submit button, change text, hide quantity elements
            $addToCart.addClass('disabled').prop('disabled', true);
            $addToCartText.html("Sold Out");
            $quantityElements.hide();
        }

        // Regardless of stock, update the product price
        $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

        // Also update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
            $comparePrice
                .html("Compare at" + ' ' + Shopify.formatMoney(variant.compare_at_price, moneyFormat))
                .show();
        } else {
            $comparePrice.hide();
        }

    } else {
        // The variant doesn't exist, disable submit button.
        // This may be an error or notice that a specific variant is not available.
        // To only show available variants, implement linked product options:
        //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
        $addToCart.addClass('disabled').prop('disabled', true);
        $addToCartText.html("Unavailable");
        $quantityElements.hide();
    }
};

timber.productImageSwitch = function () {
    if (timber.cache.$thumbImages.length) {
        // Switch the main image with one of the thumbnails
        // Note: this does not change the variant selected, just the image
        timber.cache.$thumbImages.on('click', function(evt) {
            evt.preventDefault();
            var $this = $(this),
                index = $this.parent().index(),
                newImage = $this.attr('href');

            // -SL- Custom: updating index for product zoom
            Maeree.ProductFullscreen.updateActive(index);

            timber.switchImage(newImage, null, timber.cache.$productImage);
        });
    }
};

timber.switchImage = function (src, imgObject, el) {
    // Make sure element is a jquery object
    var $el = $(el);
    $el.attr('src', src);
};

timber.responsiveVideos = function () {
    $('iframe[src*="youtube.com/embed"]').wrap('<div class="video-wrapper"></div>');
    $('iframe[src*="player.vimeo"]').wrap('<div class="video-wrapper"></div>');
};

timber.collectionViews = function () {
    if (timber.cache.$changeView.length) {
        timber.cache.$changeView.on('click', function() {
            var view = $(this).data('view'),
                    url = document.URL,
                    hasParams = url.indexOf('?') > -1;

            if (hasParams) {
                window.location = replaceUrlParam(url, 'view', view);
            } else {
                window.location = url + '?view=' + view;
            }
        });
    }
};

timber.loginForms = function() {
    function showRecoverPasswordForm() {
        timber.cache.$recoverPasswordForm.show();
        timber.cache.$customerLoginForm.hide();
    }

    function hideRecoverPasswordForm() {
        timber.cache.$recoverPasswordForm.hide();
        timber.cache.$customerLoginForm.show();
    }

    timber.cache.$recoverPasswordLink.on('click', function(evt) {
        evt.preventDefault();
        showRecoverPasswordForm();
    });

    timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
        evt.preventDefault();
        hideRecoverPasswordForm();
    });

    // Allow deep linking to recover password form
    if (timber.getHash() == '#recover') {
        showRecoverPasswordForm();
    }
};

timber.resetPasswordSuccess = function() {
    timber.cache.$passwordResetSuccess.show();
};

/*============================================================================
    Drawer modules
    - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
    var Drawer = function (id, position, options) {
        var defaults = {
            close: '.js-drawer-close',
            open: '.js-drawer-open-' + position,
            openClass: 'js-drawer-open',
            dirOpenClass: 'js-drawer-open-' + position
        };

        this.$nodes = {
            parent: $('body, html'),
            page: $('#PageContainer'),
            pageMask: $('#page-mask'),
            moved: $('.is-moved-by-drawer')
        };

        this.config = $.extend(defaults, options);
        this.position = position;

        this.$drawer = $('#' + id);

        if (!this.$drawer.length) {
            return false;
        }

        this.drawerIsOpen = false;
        this.init();
    };

    Drawer.prototype.init = function () {
        $(this.config.open).on('click', $.proxy(this.open, this));
        this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
    };

    Drawer.prototype.open = function (evt) {
        // Keep track if drawer was opened from a click, or called by another function
        var externalCall = false;

        // Prevent following href if link is clicked
        if (evt) {
            evt.preventDefault();
        } else {
            externalCall = true;
        }

        // Without this, the drawer opens, the click event bubbles up to $nodes.page
        // which closes the drawer.
        if (evt && evt.stopPropagation) {
            evt.stopPropagation();
            // save the source of the click, we'll focus to this on close
            this.$activeSource = $(evt.currentTarget);
        }

        if (this.drawerIsOpen && !externalCall) {
            return this.close();
        }

        // Add is-transitioning class to moved elements on open so drawer can have
        // transition for close animation
        //this.$nodes.moved.addClass('is-transitioning');
        timber.cache.$body.addClass('is-transitioning');
        this.$drawer.prepareTransition();

        this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
        this.drawerIsOpen = true;

        // Set focus on drawer
        this.trapFocus(this.$drawer, 'drawer_focus');

        // Run function when draw opens if set
        if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
            if (!externalCall) {
                this.config.onDrawerOpen();
            }
        }

        if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
            this.$activeSource.attr('aria-expanded', 'true');
        }

        // Lock scrolling on mobile
        this.$nodes.page.on('touchmove.drawer', function () {
            return false;
        });

        this.$nodes.pageMask.on('click.drawer', $.proxy(function () {
            this.close();
            return false;
        }, this));
    };

    Drawer.prototype.close = function () {
        if (!this.drawerIsOpen) { // don't close a closed drawer
            return;
        }

        // deselect any focused form elements
        $(document.activeElement).trigger('blur');

        // Ensure closing transition is applied to moved elements, like the nav
        //this.$nodes.moved.prepareTransition({ disableExisting: true });
        timber.cache.$body.prepareTransition({ disableExisting: true });
        this.$drawer.prepareTransition({ disableExisting: true });

        this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

        this.drawerIsOpen = false;

        // Remove focus on drawer
        this.removeTrapFocus(this.$drawer, 'drawer_focus');

        this.$nodes.page.off('.drawer');
    };

    Drawer.prototype.trapFocus = function ($container, eventNamespace) {
        var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

        $container.attr('tabindex', '-1');

        $container.focus();

        $(document).on(eventName, function (evt) {
            if ($container[0] !== evt.target && !$container.has(evt.target).length) {
                $container.focus();
            }
        });
    };

    Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
        var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

        $container.removeAttr('tabindex');
        $(document).off(eventName);
    };

    return Drawer;
})();


// Initialize Timber's JS on docready
$(timber.init);
/*!
	Zoom 1.7.14
	license: MIT
	http://www.jacklmoore.com/zoom
*/
(function($){var defaults={url:false,callback:false,target:false,duration:120,on:"mouseover",touch:true,onZoomIn:false,onZoomOut:false,magnify:1};$.zoom=function(target,source,img,magnify){var targetHeight,targetWidth,sourceHeight,sourceWidth,xRatio,yRatio,offset,$target=$(target),position=$target.css("position"),$source=$(source);$target.css("position",/(absolute|fixed)/.test(position)?position:"relative");$target.css("overflow","hidden");img.style.width=img.style.height="";$(img).addClass("zoomImg").css({position:"absolute",top:0,left:0,opacity:0,width:img.width*magnify,height:img.height*magnify,border:"none",maxWidth:"none",maxHeight:"none"}).appendTo(target);return{init:function(){targetWidth=$target.outerWidth();targetHeight=$target.outerHeight();if(source===$target[0]){sourceWidth=targetWidth;sourceHeight=targetHeight}else{sourceWidth=$source.outerWidth();sourceHeight=$source.outerHeight()}xRatio=(img.width-targetWidth)/sourceWidth;yRatio=(img.height-targetHeight)/sourceHeight;offset=$source.offset()},move:function(e){var left=e.pageX-offset.left,top=e.pageY-offset.top;top=Math.max(Math.min(top,sourceHeight),0);left=Math.max(Math.min(left,sourceWidth),0);img.style.left=left*-xRatio+"px";img.style.top=top*-yRatio+"px"}}};$.fn.zoom=function(options){return this.each(function(){var settings=$.extend({},defaults,options||{}),target=settings.target||this,source=this,$source=$(source),$target=$(target),img=document.createElement("img"),$img=$(img),mousemove="mousemove.zoom",clicked=false,touched=false,$urlElement;if(!settings.url){$urlElement=$source.find("img");if($urlElement[0]){settings.url=$urlElement.data("src")||$urlElement.attr("src")}if(!settings.url){return}}(function(){var position=$target.css("position");var overflow=$target.css("overflow");$source.one("zoom.destroy",function(){$source.off(".zoom");$target.css("position",position);$target.css("overflow",overflow);$img.remove()})})();img.onload=function(){var zoom=$.zoom(target,source,img,settings.magnify);function start(e){zoom.init();zoom.move(e);$img.stop().fadeTo($.support.opacity?settings.duration:0,1,$.isFunction(settings.onZoomIn)?settings.onZoomIn.call(img):false)}function stop(){$img.stop().fadeTo(settings.duration,0,$.isFunction(settings.onZoomOut)?settings.onZoomOut.call(img):false)}if(settings.on==="grab"){$source.on("mousedown.zoom",function(e){if(e.which===1){$(document).one("mouseup.zoom",function(){stop();$(document).off(mousemove,zoom.move)});start(e);$(document).on(mousemove,zoom.move);e.preventDefault()}})}else if(settings.on==="click"){$source.on("click.zoom",function(e){if(clicked){return}else{clicked=true;start(e);$(document).on(mousemove,zoom.move);$(document).one("click.zoom",function(){stop();clicked=false;$(document).off(mousemove,zoom.move)});return false}})}else if(settings.on==="toggle"){$source.on("click.zoom",function(e){if(clicked){stop()}else{start(e)}clicked=!clicked})}else if(settings.on==="mouseover"){zoom.init();$source.on("mouseenter.zoom",start).on("mouseleave.zoom",stop).on(mousemove,zoom.move)}if(settings.touch){$source.on("touchstart.zoom",function(e){e.preventDefault();if(touched){touched=false;stop()}else{touched=true;start(e.originalEvent.touches[0]||e.originalEvent.changedTouches[0])}}).on("touchmove.zoom",function(e){e.preventDefault();zoom.move(e.originalEvent.touches[0]||e.originalEvent.changedTouches[0])})}if($.isFunction(settings.callback)){settings.callback.call(img)}};img.src=settings.url})};$.fn.zoom.defaults=defaults})(window.jQuery);
// CUSTOM MAEREE SCRIPTS
var Maeree = Maeree || {};

// plugins
Maeree.Plugins = (function(){

    Maeree.Cache = Maeree.Mobile || {};
    Maeree.Cache.$window = $(window);

    Maeree.Mobile = Maeree.Mobile || {};
    Maeree.Mobile.isMobile = (Maeree.Cache.$window.width() < 769) ? true : false;

    Maeree.Slides = Maeree.Slides || {};
    Maeree.Slides.activeIndex = Maeree.Slides.activeIndex = 0;

    // easing definitions ripped from jQuery UI. Check $.easing in console for full list
    !function(){var n={};$.each(["Quad","Cubic","Quart","Quint","Expo"],function(t,u){n[u]=function(n){return Math.pow(n,t+2)}}),$.extend(n,{Sine:function(n){return 1-Math.cos(n*Math.PI/2)},Circ:function(n){return 1-Math.sqrt(1-n*n)},Elastic:function(n){return 0===n||1===n?n:-Math.pow(2,8*(n-1))*Math.sin((80*(n-1)-7.5)*Math.PI/15)},Back:function(n){return n*n*(3*n-2)},Bounce:function(n){for(var t,u=4;n<((t=Math.pow(2,--u))-1)/11;);return 1/Math.pow(4,3-u)-7.5625*Math.pow((3*t-2)/22-n,2)}}),$.each(n,function(n,t){$.easing["easeIn"+n]=t,$.easing["easeOut"+n]=function(n){return 1-t(1-n)},$.easing["easeInOut"+n]=function(n){return.5>n?t(2*n)/2:1-t(-2*n+2)/2}})}();

    // account for mobile sticky header
    var vOffset = (Maeree.Mobile.isMobile) ? 100 : 30;
    // smooth scroll plugin. Src: https://css-tricks.com/snippets/jquery/smooth-scrolling/
    $('.smooth-scroll').on('click', function(e) {  //$('a[href*=#]:not([href=#])')
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            if (target.length) {
                e.preventDefault();
                $('html,body').animate({
                    scrollTop: target.offset().top - vOffset
                }, 1000, "easeInOutCubic");
            }
        }
    });

    // utility fn to preload images
    var PreloadImages = function(){
        for (var i = 0; i < arguments.length; i++) {
            var img = $("<img />").attr("src", arguments[i]);
        }
    };

    return {
        PreloadImages: PreloadImages
    };

})();

var Maeree = Maeree || {};
Maeree.ProductFullscreen = (function(){

    var $mainPhoto,
        $fsWrap = $('#product-fullscreen'),
        $thumbs = $('#ProductThumbs');

    var init = function() {
        // medium and large devices only
        if (Maeree.Cache.$window.width() < 481) {
            return;
        }

        $mainPhoto = $('#ProductPhoto');
        if (!$mainPhoto.length) {
            return;
        }

        addListeners();
    };

    var openFs = function() {
        timber.cache.$body.addClass('product-fullscreen-on');
        preloadSlide(true);  // sometimes user can click before mouseenter registers
    };

    var closeFs = function(e) {
        e.preventDefault();

        $fsWrap.addClass('fade-out');
        setTimeout(function(){
            timber.cache.$body.removeClass('product-fullscreen-on');
            $fsWrap.removeClass('fade-out');
        }, 600);
    };

    // either preload one or all the huge Fullscreen images
    var preloadSlide = function(preloadAll) {
        var $el = $fsWrap.find('li[data-style]');
        if (preloadAll !== true) {
            $el.filter('.active');
        }

        if ($el.length) {
            $el.each(function(){
                var $this = $(this);
                $this.attr('style', $this.attr('data-style')).removeAttr('data-style');
            });
        }
    };

    var addListeners = function() {
        $mainPhoto
            .one('mouseenter', preloadSlide)  // preload a single slide on product mouse enter
            .on('click', openFs);

        $('#product-fullscreen-close').on('click', closeFs);
    };

    var updateActive = function(index) {
        $fsWrap.find('.slideshow-gallery li').eq(index)
            .addClass('active')
            .siblings().removeClass('active');

        // update active index
        Maeree.Slides.activeIndex = index;
        if (!Maeree.Mobile.isMobile) {
            Maeree.ProductZoom.refresh();
        }
    };

    return {
        init: init,
        updateActive: updateActive
    };

})();
var Maeree = Maeree || {};
Maeree.ProductZoom = (function() {
    "use strict";

    var $wrap,
        $photo,
        $frame,
        $context;

    var imgPos,
        contextValues;

    var init = function() {
        $photo = $('#ProductPhoto');
        if (Maeree.Mobile.isMobile || !$photo.length || typeof Maeree.Slides.large === 'undefined') {
            return;
        }

        $wrap = $('#product-single-wrap');
        $frame = $('#product-single-description');

        imgPos = $photo.offset();

        addFollowBox();

        addListeners();

    };

    var attach = function() {
        $photo.zoom({
            url: Maeree.Slides.large[Maeree.Slides.activeIndex],
            target: $frame,
            callback: imgLoaded,
            onZoomIn: zoomedIn,
            onZoomOut: zoomedOut
        });
    };

    var imgLoaded = function() {
        $wrap.addClass('zoomed-imaged-loaded');
    };

    var zoomedIn = function() {
        $wrap.addClass('zoomed-in');
    };

    var zoomedOut = function() {
        $wrap.removeClass('zoomed-in');
    };

    var destroy = function() {
        $photo.trigger('zoom.destroy');
        $wrap.removeClass('zoomed-imaged-loaded');
    };

    var refresh = function() {
        destroy();
        attach();
        imgPos = $photo.offset();
    };

    var addFollowBox = function() {
        $context = $('<div id="zoom-context" class="zoom-context" />');
        $photo.append($context);
    };

    var moveBox = function(e) {
        contextValues = contextValues || {
            width: 45,
            height: 60,
            offsetWidth: 45, // / 2,
            offsetHeight: 60 // / 2
        };

        var topPos, leftPos;

        if (
            e.pageY > (imgPos.top + contextValues.offsetHeight)
            && e.pageY < (imgPos.top + $photo.height() - contextValues.offsetHeight)
        ) {
            topPos = e.pageY - contextValues.height;
            $context.css({top: topPos});
        } else {
            //topPos = (Math.abs(e.pageY - imgPos.top) < 15) ? imgPos.top : imgPos.top + $photo.height();
        }

        if (
            e.pageX > (imgPos.left + contextValues.offsetWidth)
            && e.pageX < (imgPos.left + $photo.width() - contextValues.offsetWidth)
        ) {
            leftPos = e.pageX - contextValues.width;
            $context.css({left: leftPos});
        } else {
            //leftPos = (Math.abs(e.pageX - imgPos.left) < 15) ? imgPos.left : imgPos.left + $photo.width();
        }

        //console.log(topPos +', '+ leftPos);

        // $context.css({
        //     top: topPos,
        //     left: leftPos
        // });
    };

    var addListeners = function() {
        attach();
        $photo.on('mousemove.contextBox', moveBox);
    };

    return {
        init: init,
        refresh: refresh,
        destroy: destroy
    };

})();
var Maeree = Maeree || {};
Maeree.ScrollTop = (function() {
    
    // private references
    var offset = 300,  // browser window scroll (in pixels) after which the "back to top" link is shown
        offset_opacity = 1200,  //browser window scroll (in pixels) after which the "back to top" link opacity is reduced
        scroll_top_duration = 700,
        $back_to_top = $('.cd-top'),
        $window = Maeree.Cache.$window;

    var init = function() {
        toggleBtn();
        addListeners();
    };

    // hide or show the "back to top" link
    var toggleBtn = function() {
        $window.scroll(function(){
            ( $window.scrollTop() > offset ) ? $back_to_top.addClass('cd-is-visible') : $back_to_top.removeClass('cd-is-visible cd-fade-out');
            if( $window.scrollTop() > offset_opacity ) { 
                $back_to_top.addClass('cd-fade-out');
            }
        });
    };

    // smooth scroll to top
    var smoothScroll = function(e) {
        e.preventDefault();
        $('body,html').animate({
            scrollTop: 0 ,
            }, scroll_top_duration
        );
    };

    var addListeners = function() {
        $back_to_top.on('click', smoothScroll);
    };

    return {
        init: init
    };
})();
var Maeree = Maeree || {};
Maeree.Search = (function(){
    "use strict";

    // private elements
    var $searchWrap;

    // private references
    var searchActive = false;

    var init = function() {
        // assign references
        $searchWrap = $(".site-nav-search");
        if (!$searchWrap.length) {
            return;
        }

        addListeners();
    };

    var searchToggle = function(e){
        e.preventDefault();

        // toggle active helper
        searchActive = (searchActive) ? false : true;

        if (searchActive) {
            $searchWrap.find('input[type="search"]').focus();
        }

        timber.cache.$body.toggleClass('search-active');
    };

    var addListeners = function() {
        $('#PageContainer').on('click', '.search-toggle', searchToggle);
    };

    return {
        init: init
    };

})();
var Maeree = Maeree || {};
Maeree.ShoppingBag = (function(){

    var init = function() {
        addListeners();
    };

    var closeRight = function(e) {
        e.preventDefault();
        e.stopPropagation();
        timber.RightDrawer.close();
    };

    var addListeners = function() {
        $('.js-drawer-close-right').on('click', closeRight);
    };

    return {
        init: init
    };

})();
var Maeree = Maeree || {};
Maeree.Slideshow = function(){
    "use strict";

    // private elements
    var $slideshow,
        $slides,
        $nav;

    // private references
    var autoInterval,
        animationTime = 600;

    var init = function($ss){

        // assign references        
        $slideshow = $ss;  
        $slides = $slideshow.find('.slideshow-gallery > li');
        if ($slides.length < 2) {
            return;
        }
        $nav = $slideshow.find('.slideshow-nav-js');

        if ($slideshow.attr('data-transition') === 'slow') {
            animationTime = 1500;
        }

        if ($slideshow.attr('data-autoplay') === 'true') {
            autoPlay();
        }

        addListeners();
    };

    var autoPlay = function() {
        autoInterval = setInterval(switchSlide, 6500);
    };

    var navClick = function(e) {
        e.preventDefault();

        // pause the slideshow
        $slideshow.addClass('pause');
        clearInterval(autoInterval);

        // wait for animation to finish
        if ($slideshow.hasClass('animating')) {
            return;
        }

        var index = $(this).index();
        switchSlide(index);
    };

    var switchSlide = function(index) {
        // just use the next slide
        if (index === undefined) {
            var nextIndex = $slides.filter('.active').index() + 1,
                index = (nextIndex > $slides.length-1) ? 0 : nextIndex;
        }

        var $incomingSlide = $slides.eq(index);
        if ($incomingSlide.hasClass('active')) {
            return;
        }
        var $outgoingSlide = $slides.filter('.active');

        // add animation class
        $slideshow.addClass('animating');

        // add classes for proper z-index and opacity
        $outgoingSlide.addClass('outgoing-slide');
        $incomingSlide.addClass('incoming-slide');

        // nav active states
        $nav.find('> li').eq(index)
            .addClass('active')
            .siblings().removeClass('active');

        setTimeout(function(){
            endAnimation($outgoingSlide, $incomingSlide);
        }, animationTime);
    };

    var endAnimation = function($outgoing, $incoming) {

        $incoming
            .addClass('active')
            .removeClass('incoming-slide')
            .siblings().removeClass('active');

        $outgoing.removeClass('outgoing-slide');

        $slideshow.removeClass('animating');
    };

    var addListeners = function() {
        $nav.on('click', 'li', navClick);
    };

    return {
        init: init
    };

};
var Maeree = Maeree || {};
Maeree.Social = (function(){

    var $shareWrap;

    var init = function() {

        $shareWrap = $('.social-media-share');
        if (!$shareWrap.length) {
            return;
        }

        addListeners();
    };

    var shareIt = function(e) {
        e.preventDefault();

        var $this = $(this);

        if ( $this.hasClass('share-pinterest') ) {            
            pinterestShare($this);
        } else if ( $this.hasClass('share-facebook') ) {
            facebookShare();
        }
    };

    var pinterestShare = function($this) {
        var link = $this.find('a').attr('href');
        popup(link);
    };

    var facebookShare = function() {
        var u=location.href,
            t=document.title,
            link = 'http://www.facebook.com/sharer.php?u='+encodeURIComponent(u)+'&t='+encodeURIComponent(t);
        popup(link);
    };

    var popup = function(link) {
        var width = 600,
            height = 500,
            leftPosition,
            topPosition;

        //Allow for borders.
        leftPosition = (window.screen.width / 2) - ((width / 2) + 10);
        //Allow for title and status bars.
        topPosition = (window.screen.height / 2) - ((height / 2) + 50);

        var windowFeatures = "status=no,height=" + height + ",width=" + width + ",resizable=yes,left=" + leftPosition + ",top=" + topPosition + ",screenX=" + leftPosition + ",screenY=" + topPosition + ",toolbar=no,menubar=no,scrollbars=no,location=no,directories=no";
        window.open(link,'sharer', windowFeatures);
    };

    var addListeners = function() {
        $('.social-media-share').on('click', 'li', shareIt);
    };

    return {
        init: init
    };

})();
// stick header to top for mobile
var Maeree = Maeree || {};
Maeree.StickyHeader = (function(){

    // private elements
    var $mobileHeader;

    // private helpers
    var threshold = 53;

    var init = function() {
        $mobileHeader = $('#mobile-header').find('> *');
        if (!$mobileHeader.length) {
            return;
        }

        addListeners();
    };

    var stickyHead = function() {
        var yPos = window.pageYOffset,
            classAction = (yPos > threshold) ? 'addClass' : 'removeClass';

        $mobileHeader[classAction]('sticky');

    };

    var addListeners = function() {
        //var throttled = _.throttle(events.windowScroll, 100);
        Maeree.Cache.$window.on('scroll', stickyHead);
    };

    return {
        init: init
    };

})();
var Maeree = Maeree || {};
Maeree.Subscribe = (function() {

    var $formWrap,
        $form;

    var init = function() {
        $form = $('#mailchimp-form');
        $statusMsg = $('.status-msg');
        if (!$form.length) {
            return; 
        }
        $formWrap = $form.closest('.mailchimp-form-wrap');

        addListeners();
    };

    var emailReceived = function(data) {

        if (data.result === 'success') {
            $formWrap.addClass('complete');
            $statusMsg.html(data.msg);
        } else {
            mailchimpError(data);
        }
    };

    var mailchimpError = function(data) {
        // alert('Sorry, there has been an error. Please check your email and try again.');
        if (data.msg === "0 - Please enter a value") {
            $statusMsg.html("Please enter a valid email address");
        } else {
            $statusMsg.html(data.msg);
        }
        $formWrap.removeClass('processing');

        console.log("mailchimp error: ", $statusMsg.text(), data.msg);
    };

    var processForm = function(e){
        e.preventDefault();

        if ($formWrap.hasClass('processing')) {
            return;
        }

        // iOS has ratchet HTML5 form validation
        if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
            var $inputEmail = $form.find('input[type=email]');
            if ($inputEmail.val().length < 5 || $inputEmail.val().indexOf('@') < 1) {
                return alert('Please enter a valid email address');
            }
        }

        $formWrap.addClass('processing');

        // console.log("data sent: ", $form.serialize() );

        // helper endpoint
        $.ajax({
            // url: 'https://subscriptions.maeree.com/signup.php',
            // Some helpful info:
            // http://stackoverflow.com/questions/8425701/ajax-mailchimp-signup-form-integration
            // 
            // based on the article above, this is our action url that is set in the shopify admin
            // //maeree.us11.list-manage.com/subscribe/post-json?u=1129ba098048f1dd019571759&amp;id=6a152c9994&c=?
            url: $form.attr('action'),
            type: 'GET',
            data: $form.serialize(),
            dataType: 'jsonp',
            success: emailReceived,
            error: mailchimpError
        });
    };

    var addListeners = function() {
        $form.on('submit', processForm);
    };

    return {
        init: init
    };

})();
// list the functions you want to fire on DOM Ready
var Maeree = Maeree || {};
Maeree.init = function() {
    Maeree.Search.init();
    Maeree.ScrollTop.init();
    Maeree.StickyHeader.init();
    Maeree.Social.init();
    Maeree.Subscribe.init();
    Maeree.ProductFullscreen.init();
    Maeree.ProductZoom.init();

    //Maeree.ShoppingBag.init();  // trying to prevent janky animation. Not working

    $('.slideshow-js').each(function(){
        new Maeree.Slideshow().init($(this));
    });
};

// fire init on DOM ready
$(Maeree.init);